const commonDataPlugin = {

    install(Vue, options) {
        let commonDataPlugin = {
            hubConnected: false,
            hubOnCloseSet: false,
            logged: false
        };
        Vue.prototype.$commonData = commonDataPlugin;
    }

}

export default commonDataPlugin;